import { defineStore } from 'pinia'
import BinancePublicClient from '@/service/binancePublicClient.js'
import BinancePrivateClient from '@/service/binancePrivateClient.js'
import OkxPublicClient from '@/service/okxPublicClient.js'
import OkxPrivateClient from '@/service/okxPrivateClient.js'


export const useSystemStore = defineStore('system', {
    state: () => ({
        password: "",
        api: null,
        assetType: "", //操作的资产类型
        platform: "",  // 选择的交易所平台
        exchangeInfo: [],  // 交易所全部交易对
        uexchangeInfo: [],  // U本位合约交易对
        usymbols: [],  //自定义交易对信息
        /*
            当前选择的合约交易对
            name: 通用名字 BTCUSDT,
            symbol: 各交易所的标准symbol,
            amount: 数量精度,
            price: 价格精度,
            binanceConfig: Binance交易所专用设置
            { 
                marginType: 仓位模式,
                leverage: 杠杆,
            },
            okxConfig: OKX交易所专用设置
            { 
                marginType: 仓位模式,
                crossLongLeverage: 全仓多头杠杆,
                crossShortLeverage: 全仓空投杠杆,
                isolatedLongLeverage: 逐仓多头杠杆,
                isolatedShortLeverage: 逐仓空头杠杆,
            }
        */
        //格式与usymbols的元素一样
        currentusymbol: {},
        //触发Usymbol的选择事件
        changeUsymbol: 0,
        // OKX和Binance的API客户端实例
        publicClient: null,
        privateClient: null,
    }),
    actions: {
        setPassword(data) {
            this.$patch({ password: data })
        },
        setApi(data) {
            this.$patch({ api: data })
        },
        initOkxClient() {
            this.privateClient = new OkxPrivateClient(this.api)
            this.publicClient = new OkxPublicClient()
        },
        initBinanceClient() {
            this.privateClient = new BinancePrivateClient(this.api)
            this.publicClient = new BinancePublicClient()
        },
        setAssetType(data) {
            this.$patch({ assetType: data })
        },
        setPlatform(data) {
            this.$patch({ platform: data })
        },
        setExchangeInfo(data) {
            this.$patch({ exchangeInfo: data })
        },
        setUExchangeInfo(data) {
            this.$patch({ uexchangeInfo: data })
        },
        setUSymbols(data) {
            this.$patch({ usymbols: data })
        },
        setCurrentusymbol(data) {
            this.$patch({ currentusymbol: data })
        },
        updateBinanceConfig(data) {
            //同时更新usymbols、currentusymbol
            const { name, config } = data
            const target = this.usymbols.find(item => item.name === name)
            if (target) {
                target.binanceConfig.marginType = config.marginType
                target.binanceConfig.leverage = config.leverage
            }
            this.currentusymbol.binanceConfig.marginType = config.marginType
            this.currentusymbol.binanceConfig.leverage = config.leverage
        },
        updateOkxMarginType(data) {
            //同时更新usymbols、currentusymbol
            const { name, marginType } = data
            const target = this.usymbols.find(item => item.name === name)
            if (target) {
                target.okxConfig.marginType = marginType
            }
            this.currentusymbol.okxConfig.marginType = marginType
        },
        updateOkxConfig(data) {
            //同时更新usymbols、currentusymbol
            const { name, config } = data
            const target = this.usymbols.find(item => item.name === name)

            if (target) {
                target.okxConfig.crossLongLeverage = config.crossLongLeverage
                target.okxConfig.crossShortLeverage = config.crossShortLeverage
                target.okxConfig.isolatedLongLeverage = config.isolatedLongLeverage
                target.okxConfig.isolatedShortLeverage = config.isolatedShortLeverage
            }
            this.currentusymbol.okxConfig.crossLongLeverage = config.crossLongLeverage
            this.currentusymbol.okxConfig.crossShortLeverage = config.crossShortLeverage
            this.currentusymbol.okxConfig.isolatedLongLeverage = config.isolatedLongLeverage
            this.currentusymbol.okxConfig.isolatedShortLeverage = config.isolatedShortLeverage
        },
        triggerChangeUsymbol() {
            this.changeUsymbol++
        }
    }
})

